import { documentHasElements } from "modules/dom";

documentHasElements(".js-horizontal-accordion-block", (horizontalAccordionBlocks) => {
    horizontalAccordionBlocks.forEach((horizontalAccordionBlock) => {

        const tabBlocks = horizontalAccordionBlock.querySelector<HTMLElement>(".tab-blocks");
        const blocks = horizontalAccordionBlock.querySelectorAll<HTMLDivElement>(".tab-blocks > div");        

        blocks.forEach((tab: HTMLDivElement, index: number) => {
            tab.setAttribute("data-item", index.toString());

            const overlay = document.createElement("div");
            overlay.className = "col overlay";

            if (index === 0) {
                tab.querySelector<HTMLElement>(".text")?.classList.add("active");
                tab.querySelector<HTMLElement>(".text")?.classList.add("show");
            }

            tab.querySelector<HTMLElement>(".block")?.appendChild(overlay);

            tab.addEventListener("click", () => {
                if (!tab.classList.contains("active") && !tabBlocks?.classList.contains("delayed")) {
                    // Remove current active states
                    horizontalAccordionBlock.querySelector<HTMLDivElement>(".tab-blocks > div.active")?.classList.remove("active");
                    horizontalAccordionBlock.querySelector<HTMLElement>(".tab-blocks .text.active")?.classList.remove("active");
                    horizontalAccordionBlock.querySelector<HTMLElement>(".tab-blocks .text.show")?.classList.remove("show");

                    tab.classList.add("active");

                    setTimeout(() => {
                        tab.querySelector<HTMLElement>(".text")?.classList.add("active");
                    }, 600);

                    setTimeout(() => {
                        tab.querySelector<HTMLElement>(".text")?.classList.add("show");
                    }, 650);

                    setTimeout(() => {
                        tabBlocks?.classList.remove("delayed");
                    }, 800);
                }

                tabBlocks?.classList.add("delayed");
            });
        });

    });
});
